<mat-toolbar class="toolbar">
  <span>aaaa</span>
  <div class="app-title">
    UC+ファイルシェア
  </div>
</mat-toolbar>
  <mat-card class="main-card" appearance="outlined">
    <mat-card-header>
      <mat-card-title></mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <router-outlet/>
    </mat-card-content>
    <mat-card-footer class="footer">
    </mat-card-footer>
  </mat-card>
